export const hashParameters = {
    BELL: 'bell',
    CALL: 'call',
    SEARCH: 'search'
};
